import { makeStyles } from '@material-ui/core/styles';

import { userTheme } from 'consts/config';

export default makeStyles(theme => ({
  ExistingWithTree: {
    '&__expand-bar': {
      cursor: 'pointer',
      height: '50px',
      marginTop: '0px !important',
      '&--children-border': {
        borderBottom: `3px solid ${theme.palette.primary.main}`,
        borderBottomLeftRadius: '12px',
        borderBottomRightRadius: '12px',
        borderLeft: `1px solid ${theme.palette.existingOrganizations.linkColor}`,
        borderRight: `1px solid ${theme.palette.existingOrganizations.linkColor}`,
      },
      '&__arrow': {
        color:
          theme.palette.type === userTheme.dark
            ? theme.palette.text.primary
            : 'rgba(0, 0, 0, 0.54)',
        marginLeft: 'auto',
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shortest,
        }),
        '&:hover': {
          backgroundColor: 'transparent',
        },
        '&--open': {
          transform: 'rotate(180deg)',
        },
      },
    },
    '&__card': {
      backgroundColor: theme.palette.existingOrganizations.cardColor,
      '&:hover': {
        backgroundColor: theme.palette.existingOrganizations.hoverCardColor,
        opacity: 0.9,
      },
    },
    '&--padding-left': {
      paddingLeft: '15px',
    },
  },
}));
